// extracted by mini-css-extract-plugin
export default {"iconContainer":"iconButton_iconContainer__OMbYm","badgeNotification":"iconButton_badgeNotification__D+Sdv"};